import React, {useCallback, useContext, useEffect, useState} from 'react'
import {Col, Form, Row, Stack} from 'react-bootstrap'
import {useLocation} from 'react-router-dom'
import Select, {SingleValue} from 'react-select'
import {getDocsToApprove, getProcessAndUnidsWhereNeedApprove} from '../../../../services/documentos'
import {fetchMenuActionsByRole, fetchSubMenuByUrl} from '../../../../services/menu'
import {showMessage} from '../../../../shared/Alerts'
import {useAuth2} from '../../../authv2/Auth2Provider'
import {DatePickerBusiness} from '../../../generales_component/DatePickerBusiness'
import {AprobacionAnyContext} from '../AprobacionAnyContext'

interface Option {
  label: string
  value: string
}

export const AprobacionAnyHeader: React.FC = () => {
  const {
    setIdProceso,
    setUnidad,
    setSearchTerm,
    setDates,
    setPackages,
    setPermissions,
    setTotalPages,
    setLoading,
    Dates,
    idProceso,
    unidad,
    searchTerm,
    sortBy,
    page,
    setPage,
  } = useContext(AprobacionAnyContext)
  const location = useLocation()
  const [processList, setProcessList] = useState<Option[]>([])
  const [unitList, setUnitList] = useState<Option[]>([])
  const {selectedRole, selectedCompanyId, userData} = useAuth2()

  useEffect(() => {
    const fetchPermissions = async () => {
      const response = await fetchMenuActionsByRole(selectedRole)
      if (response.success) {
        const currentPath = location.pathname
        console.log('currentpath' + JSON.stringify(currentPath))
        const subMenuResponse = await fetchSubMenuByUrl(currentPath)
        if (subMenuResponse.success) {
          console.log('PERMISOS' + JSON.stringify(subMenuResponse))
          const subMenuId = subMenuResponse.data.id_hijo
          const permissionsForSubMenu =
            response.data.find((item: any) => item.subMenuId === subMenuId)?.acciones || []
          setPermissions(permissionsForSubMenu)
        }
      }
    }

    fetchPermissions()
  }, [selectedRole, selectedCompanyId])

  useEffect(() => {
    fetchFilters()
  }, [])

  useEffect(() => {
    if (!idProceso) {
    } else {
      fetchDocsToApprove()
    }
  }, [idProceso, unidad, Dates, searchTerm, sortBy, page])

  const fetchFilters = useCallback(async () => {
    const response = await getProcessAndUnidsWhereNeedApprove()

    const unidadesDefault = [
      {
        label: 'Seleccione una Unidad',
        value: '',
      },
    ]

    if (response.success) {
      const unidades =
        response?.data?.unidades?.map((unidad: any) => ({
          label: unidad.name,
          value: unidad.id,
        })) ?? []
      setUnitList([...unidadesDefault, ...unidades])

      const procesos =
        response?.data?.procesos?.map((proceso: any) => ({
          label: proceso.name,
          value: proceso.id,
        })) ?? []
      setIdProceso(procesos?.[0]?.value ?? '')
      setProcessList([...procesos])
    } else {
      showMessage('error', 'Error al cargar los filtros', response.message)
    }
  }, [])

  const fetchDocsToApprove = useCallback(async () => {
    try {
      setLoading(true)
      const docsResponses = await getDocsToApprove({
        id_proceso: idProceso,
        searchQuery: searchTerm,
        entryDateFrom: Dates?.[0] ?? null,
        entryDateTo: Dates?.[1] ?? null,
        sortBy: sortBy.columnName,
        sortOrder: sortBy.sortDirection,
        unidad,
        page,
      })

      if (docsResponses.success) {
        setPackages(docsResponses.data)
        setTotalPages(
          docsResponses?.totalPages
            ? docsResponses?.totalPages === 0
              ? 1
              : docsResponses?.totalPages
            : 1
        )
      }
    } catch (error) {
      console.error('Error fetching documents to approve:', error)
    } finally {
      setLoading(false)
    }
  }, [idProceso, unidad, Dates, searchTerm, sortBy, page])

  const handleSearch = (value: string) => {
    setSearchTerm(value)
    setPage(1)
  }

  const handleProcessChange = (e: SingleValue<Option>) => {
    setIdProceso(e?.value ?? '')
    setPage(1)
  }

  const handleUnitChange = (e: SingleValue<Option>) => {
    setUnidad(e?.value ?? '')
    setPage(1)
  }

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    setDates(dates)
    setPage(1)
  }

  return (
    <>
      <div className='mx-8 mt-8 mb-2'>
        <Row className='mb-4'>
          <Col>
            <Stack direction='vertical' className='h-100' gap={3}>
              <span className='fw-bold me-2'>Proceso:</span>
              <Select
                placeholder='Seleccione un Proceso'
                options={processList}
                onChange={handleProcessChange}
                value={
                  idProceso
                    ? processList.find((option) => option.value === idProceso)
                    : processList?.[0]
                }
              />
            </Stack>
          </Col>
          <Col>
            <Stack direction='vertical' gap={3}>
              <span className='fw-bold me-2'>Unidad:</span>
              <Select
                placeholder='Seleccione una Unidad'
                options={unitList}
                onChange={handleUnitChange}
              />
            </Stack>
          </Col>
          <Col>
            <Stack direction='vertical' gap={3}>
              <span className='fw-bold'>Buscar</span>
              <Form.Control
                type='text'
                className={'form-control-sm same-height'}
                placeholder='Buscar Nombre de Paquete'
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </Stack>
          </Col>

          <Col>
            <Stack direction='vertical' gap={3}>
              <span className='fw-bold'>Rangos de Fecha de Carga</span>
              <DatePickerBusiness
                className='flex-grow-1'
                value={Dates}
                onChange={handleDateChange}
              />
            </Stack>
          </Col>
        </Row>
      </div>
    </>
  )
}
